module.exports = __webpack_public_path__ + "static/media/comment-alt-minus.0acc8c6e.svg";